<div class="tab-inner-content">
  <h2>Aging Report for Vendor Invoice</h2>
  <table>
    <thead>
      <tr>
        <th>Vendor Invoice No</th>
        <th>Vendor Name</th>
        <th>Amount (in AED)</th>
        <th>Due Date</th>
        <th>Status</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngIf="agingVendorInvoice && agingVendorInvoice.length > 0; else noData">
        <ng-container *ngFor="let item of agingVendorInvoice">
          <tr class="child">
            <td>{{ item.billDetails?.billNo }}</td>
            <td>{{ item.billDetails?.vendorData?.vendorName }}</td>
            <td>{{ item?.billDetails.balance }}</td>
            <td>{{ item?.billDetails?.dueDate | date : "mediumDate" }}</td>
            <td>{{ getOverdueText(item?.billDetails?.dueDate) }}</td>
          </tr>
        </ng-container>
      </ng-container>
      <ng-template #noData>
        <tr>
          <td colspan="5" class="no-data">
            No data available.
          </td>
        </tr>
      </ng-template>
    </tbody>
  </table>
</div>